<template>
  <Modal v-model="visible" title="参考须知" width="800px">
    <BrowserTest ref="$test" isDialog />
    <template slot="footer">
      <template v-if="browserSupportStatus !== BROWSER_SUPPORT_STATUS.NOT_SUPPORT">
        <Button
          type="primary"
          long
          @click="handleStartExam">
          开始考试 {{ timer ? `（ ${timer} ）` : '' }}
        </Button>
        <p class="text-left margin-top-10px">
          <Checkbox v-model="read">我已阅读并同意参考须知内容，我将为考试过程中出现的任何作弊行为负责</Checkbox>
        </p>
      </template>
      <Button
        type="error"
        long
        v-else>当前浏览器或电脑不支持参加考试</Button>
    </template>
    
  </Modal>
</template>

<script>
import { mapState } from 'vuex'
import { BROWSER_SUPPORT_STATUS, COUNTER_TIMER } from '../../libs/constant'
import { sleep } from '../../libs/util'
import BrowserTest from '../../components/BrowserTest'

export default {
  components: { BrowserTest },
  data () {
    return {
      read: false,
      timer: COUNTER_TIMER,
      BROWSER_SUPPORT_STATUS
    }
  },
  computed: {
    ...mapState([ 'browserSupportStatus' ])
  },
  created () {
    const interval = setInterval(() => {
      this.timer--
      if (this.timer <= 0) clearInterval(interval)
    }, 1000)
  },
  handlers: {
    handleStartExam () {
      if (this.timer) return
      if (!this.read) {
        window.toast.info('请先同意参考须知才能进入考试')
        return
      }
      this.visible = false
      if (this.browserSupportStatus === BROWSER_SUPPORT_STATUS.NOT_TEST) {
        this.functionSupportTest()
      } else {
        this.enterExamination()
      }
    }
  },
  methods: {
    async functionSupportTest () {
      const support = await this.$refs.$test.testBrowserSupport({ hideLoading: false, showSuccessNotice: false })
      if (support) {
        window.showLoading('检测完成，即将进入考试...')
        await sleep(3)
        this.enterExamination()
      }
    },

    enterExamination () {
      this.$router.push({
        name: 'examination',
        params: { courseId: this.courseId }
      })
    }
  }
}
</script>

